<div class="carousel-container"
  (mouseover)="handleMouseoverContainer($event)"
  (mouseout)="handleMouseoutContainer($event)"
  [class.is-paused]="isPaused"
  [ngClass]="containerClass">

  <div *ngIf="!items || items.length == 0" class="carousel__wrapper">
    <ng-content *ngTemplateOutlet="carouselMediaSlideGroup; context:{ media: media, direction: direction }"></ng-content>
    <!-- duplicate needed for infinite scroll: -->
    <ng-content *ngTemplateOutlet="carouselMediaSlideGroup; context:{ media: media, direction: direction }"></ng-content>
  </div>

  <div *ngIf="!!items" class="carousel__wrapper">
    <ng-content *ngTemplateOutlet="carouselItemSlideGroup; context:{ items: items, direction: direction }"></ng-content>
    <!-- duplicate needed for infinite scroll: -->
    <ng-content *ngTemplateOutlet="carouselItemSlideGroup; context:{ items: items, direction: direction }"></ng-content>
  </div>
</div>



<ng-template #carouselMediaSlideGroup let-media="media" let-dir="direction">
  <ng-container *ngFor="let item of media">
    <ng-content *ngTemplateOutlet="carouselMediaSlide; context:{ src: lcpHelper.srcFromMedia(item), dir: dir }"></ng-content>
  </ng-container>
</ng-template>

<ng-template #carouselMediaSlide let-src="src" let-dir="dir">
  <div class="carousel__slide"
    (mouseover)="handleMouseoverSlide($event)"
    (mouseout)="handleMouseoutSlide($event)"
    [ngClass]="'is-direction-' + dir">

    <div *ngIf="src" class="carousel__image" [style.background-image]="'url(' + src + ')'"></div>

    <div *ngIf="!src" class="carousel__image is-placeholder"></div>
    <!-- <div class="carousel__image" [style.background-image]="'url(' + src + ')'"></div> -->
  </div>
</ng-template>



<ng-template #carouselItemSlideGroup let-items="items" let-dir="direction">
  <ng-container *ngFor="let item of items">
    <ng-content *ngTemplateOutlet="carouselItemSlide; context:{ item: item, dir: dir }"></ng-content>
  </ng-container>
</ng-template>


<ng-template #carouselItemSlide let-item="item" let-dir="dir">
  <ng-container *ngIf="!item.fields['linkAddress']">
    <ng-content *ngTemplateOutlet="carouselMediaSlide; context:{ src: lcpHelper.srcFromMedia(item.fields['media'][0]), dir: dir }"></ng-content>
  </ng-container>

  <ng-container *ngIf="item.fields['linkAddress']">
    <a class="carousel__slide"
      target="_blank"
      (mouseover)="handleMouseoverSlide($event)"
      (mouseout)="handleMouseoutSlide($event)"
      [ngClass]="'is-direction-' + dir"
      (click)="handleSelectItem(item)"
      [href]="item.fields['linkAddress']"
      [title]="item.fields['linkText']">

      <div *ngIf="item" class="carousel__image" [style.background-image]="'url(' + lcpHelper.srcFromMedia(item.fields['media'][0]) + ')'"></div>

      <div *ngIf="!item" class="carousel__image is-placeholder"></div>
      <!-- <div class="carousel__image" [style.background-image]="'url(' + src + ')'"></div> -->
    </a>
  </ng-container>
  
  <!-- <a class="carousel__slide"
    target="_blank"
    (mouseover)="handleMouseoverSlide($event)"
    (mouseout)="handleMouseoutSlide($event)"
    [ngClass]="'is-direction-' + dir"
    (click)="handleSelectItem(item)"
    [href]="item.fields['linkAddress']"
    [title]="item.fields['linkText']">

    <div *ngIf="item" class="carousel__image" [style.background-image]="'url(' + lcpHelper.srcFromMedia(item.fields['media'][0]) + ')'"></div>

    <div *ngIf="!item" class="carousel__image is-placeholder"></div>
  </a> -->
</ng-template>
